export const trackPlaylistItemClicks = () => {
    document.querySelectorAll('.playlist-player').forEach((container) => {
        container.addEventListener(
            'click',
            (event) => {
                const card = event
                    .composedPath()
                    .find((node) => node instanceof HTMLElement && node.classList.contains('js_playlistItemCard')) as
                    | HTMLElement
                    | undefined;

                const videoId = card?.dataset.videoId;

                if (!videoId) return;

                window.gtag?.('event', 'targeted_content_clicked', {
                    event_category: 'Clicks',
                    event_label: videoId,
                });
            },
            true,
        );
    });
};
